import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-400']};
  padding: ${space['space-100']};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${radius('input', 'radius-full')};
`;

export const StepButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: ${primitives.size['size-1200']};
  padding: ${space['space-300']} ${space['space-500']};
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  transition: opacity 0.15s ease;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.7;
  }
`;

export const Value = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  text-align: center;
  white-space: nowrap;
`;
